// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__-gLQ6","title":"AfterFrontImage_title__1xgKu"};